"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieUtil = void 0;
/**
 * Utility class for interacting with browser cookies.
 */
class CookieUtil {
    /**
     * Sets a cookie with the given name, value, and options.
     *
     * @param name - The name of the cookie.
     * @param value - The value of the cookie.
     * @param options - Optional settings for the cookie, including domain, path, expiration, etc.
     */
    static set(name, value, options) {
        let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        if (options === null || options === void 0 ? void 0 : options.expiresAt) {
            const expires = new Date(Date.now() + options.expiresAt).toUTCString();
            cookieString += `; expires=${expires}`;
        }
        if (options === null || options === void 0 ? void 0 : options.path) {
            cookieString += `; path=${options.path}`;
        }
        if (options === null || options === void 0 ? void 0 : options.credentialsDomain) {
            cookieString += `; domain=${options.credentialsDomain}`;
        }
        if (options === null || options === void 0 ? void 0 : options.secure) {
            cookieString += '; secure';
        }
        if (options === null || options === void 0 ? void 0 : options.sameSite) {
            cookieString += `; samesite=${options.sameSite}`;
        }
        document.cookie = cookieString;
    }
    /**
     * Retrieves the value of the cookie with the given name.
     *
     * @param name - The name of the cookie to retrieve.
     * @returns The value of the cookie, or null if the cookie does not exist.
     */
    static get(name) {
        const cookies = document.cookie.split('; ').reduce((acc, cookie) => {
            const [key, value] = cookie.split(/=(.*)/);
            acc[decodeURIComponent(key)] = decodeURIComponent(value);
            return acc;
        }, {});
        return cookies[name] || null;
    }
    /**
     * Removes the cookie with the given name and options.
     *
     * @param name - The name of the cookie to remove.
     * @param options - The options for the cookie, including domain, path, etc.
     */
    static remove(name, options) {
        let cookieString = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
        if (options === null || options === void 0 ? void 0 : options.path) {
            cookieString += `; path=${options.path}`;
        }
        if (options === null || options === void 0 ? void 0 : options.credentialsDomain) {
            cookieString += `; domain=${options.credentialsDomain}`;
        }
        if (options === null || options === void 0 ? void 0 : options.secure) {
            cookieString += '; secure';
        }
        if (options === null || options === void 0 ? void 0 : options.sameSite) {
            cookieString += `; samesite=${options.sameSite}`;
        }
        document.cookie = cookieString;
    }
    /**
     * Retrieves all cookie names.
     *
     * @returns An array of all cookie names.
     */
    static getAll() {
        return document.cookie.split('; ').map(cookie => decodeURIComponent(cookie.split('=')[0]));
    }
}
exports.CookieUtil = CookieUtil;
//# sourceMappingURL=cookies.js.map